module.exports = __webpack_public_path__ + "img/success-n.b345f254.svg";